export default __webpack_public_path__ + "static/media/mouse-04.d4a9bd17.jpg";